const Cancel = () => {
    return (
        <div className='h-fit w-full relative overflow-hidden'>
            <div className='flex flex-col items-center justify-center relative z-10'>
                <img
                    src='https://images.halalfull.com/dev/assets/img/no_orders_img.jpg'
                    alt=''
                    className='md:w-fit md:h-96'
                />
                <div className='text-center mb-8 transform transition-all duration-700 delay-300 space-y-5 flex-col'>
                    <h1 className='text-primary-text text-lg md:text-4xl font-semibold'>
                        Something Went Wrong.
                    </h1>
                    <p className='text-black text-md'>Your PayPal Transaction has been Canceled.</p>
                    <button className='main-btn px-10 py-3'>Back to Home</button>
                </div>
            </div>
        </div>
    );
};

export default Cancel;
